// extracted by mini-css-extract-plugin
module.exports = {"BLOCK":"Weather_BLOCK__1x5kO","icon":"Weather_icon__1Sewu","tempText":"Weather_tempText__3Lomx","temperatureRow":"Weather_temperatureRow__3f5d2","sunInfo":"Weather_sunInfo__1PYaj"};